import * as actions from './actions';
import * as constants from './constants';
import { reducer } from './reducer';
import { initialAction } from './initialAction';
export const tolgeeModule = {
    actions,
    containers: {
        tolgee: () => null, // minimal react component to comply with the container interface
    },
    constants,
    reducer,
    initalAction: initialAction,
};
